// Re-exports from unified color system
import { useMemo } from 'react';
import { PRIMITIVE_COLORS, SEMANTIC_COLORS, COMPONENT_COLORS } from '../residentColors';
import { useThemeColors } from '@/hooks/residents/useThemeColors';

export const EVENTS_COLORS = {
  background: SEMANTIC_COLORS.background.primary,
  cardBackground: SEMANTIC_COLORS.background.secondary,
  imageBackground: SEMANTIC_COLORS.background.tertiary,
  navHeaderBackground: PRIMITIVE_COLORS.resioBlue,
  navHeaderPastBackground: PRIMITIVE_COLORS.resioPurple,
  buttonPink: PRIMITIVE_COLORS.resioPink,
  buttonPinkText: SEMANTIC_COLORS.text.inverse,
  textPrimary: SEMANTIC_COLORS.text.primary,
  textMuted: PRIMITIVE_COLORS.gray300,
  textSecondary: PRIMITIVE_COLORS.gray400,
  iconGray: PRIMITIVE_COLORS.gray400,
  borderColor: PRIMITIVE_COLORS.gray700,
  labelBackground: PRIMITIVE_COLORS.white10,
  gradientStart: COMPONENT_COLORS.gradient.orangeadeStart,
  gradientEnd: COMPONENT_COLORS.gradient.orangeadeEnd,
  linkBlue: PRIMITIVE_COLORS.resioBlueLight,
  carouselDotActive: COMPONENT_COLORS.carousel.dotActive,
  carouselDotInactive: PRIMITIVE_COLORS.gray600,
  carouselBackground: COMPONENT_COLORS.carousel.background,
  attendingBadgeBackground: COMPONENT_COLORS.badge.attendingBg,
  attendingBadgeText: COMPONENT_COLORS.badge.attendingText,
  calendarIconActive: PRIMITIVE_COLORS.resioPink,
} as const;

export type EventsColorKey = keyof typeof EVENTS_COLORS;

export function useEventsColors() {
  const { semantic, components, colors } = useThemeColors();
  return useMemo(() => ({
    background: semantic.background.primary,
    cardBackground: semantic.background.secondary,
    imageBackground: semantic.background.tertiary,
    navHeaderBackground: components.nav.headerBlue,
    navHeaderPastBackground: components.nav.headerPurple,
    buttonPink: semantic.interactive.secondary,
    buttonPinkText: semantic.text.inverse,
    textPrimary: semantic.text.primary,
    textMuted: semantic.text.secondary,
    textSecondary: semantic.text.tertiary,
    iconGray: semantic.icon.secondary,
    borderColor: semantic.border.secondary,
    labelBackground: colors.activityIcon.bg,
    gradientStart: components.gradient.orangeadeStart,
    gradientEnd: components.gradient.orangeadeEnd,
    linkBlue: semantic.text.link,
    carouselDotActive: components.carousel.dotActive,
    carouselDotInactive: components.carousel.dotInactive,
    carouselBackground: components.carousel.background,
    attendingBadgeBackground: components.badge.attendingBg,
    attendingBadgeText: components.badge.attendingText,
    calendarIconActive: semantic.interactive.secondary,
  }), [semantic, components, colors]);
}
